import React, { useEffect } from "react";
import { FormView, PagesHeader } from "../../components/Courses";
import { useDispatch } from "react-redux";
import { getCourseInfo, getCourseFilter } from "../../appRedux/actions/courses";
import Page from "../../components/Common/Page";
import { getFreeCurrencyApi } from "../../appRedux/actions/common";
import { useParams } from "react-router-dom";
import { Tabs } from "antd";
import CourseFAQList from "../../components/Courses/FAQ/CourseFAQList";
import CourseDecisionBox from "../../components/Courses/DecisionBox/CourseDecisionBox";
import CourseSkillsTab from "../../components/Courses/Skills/CourseSkillsTab";
import CourseLevelTab from "../../components/Courses/Level/CourseLevelTab";

const CourseUpdate = () => {
  const { courseId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCourseInfo(courseId));
  }, [courseId, dispatch]);
  useEffect(() => {
    dispatch(getCourseFilter({}));

    dispatch(getFreeCurrencyApi());
  }, [dispatch]);
  return (
    <Page title="Course">
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <PagesHeader
            pageTitle={"Course Update"}
            homePageUrl="/"
            homePageText="Dashboard"
            innerPageUrl={"/course/list"}
            innerPageText={"Course List"}
            activePageText={"Update Course"}
            floatRight={""}
          />
          <div className="card">
            <div className="card-body">
              <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab="Course Details" key="1">
                  <FormView isUpdate={true} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="FAQs" key="2">
                  <CourseFAQList courseId={courseId} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Decision Box" key="3">
                  <CourseDecisionBox courseId={courseId} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Skills" key="4">
                  <CourseSkillsTab courseId={courseId} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Level" key="5">
                  <CourseLevelTab courseId={courseId} />
                </Tabs.TabPane>
              </Tabs>
            </div>
          </div>
          {/* 
          <div className="card">
            <div className="card-body">
              <MetaTagForm />
            </div>
          </div> */}
        </div>
        {/* /Page Content */}
      </div>
    </Page>
  );
};

export default CourseUpdate;
